import PropertyApartmentsColor from './PropertyApartmentsColour.svg';
import PropertyApartmentsDark from './PropertyApartmentsDark.svg';
import PropertyApartmentsLight from './PropertyApartmentsLight.svg';
export const propertyApartments = {
    color: PropertyApartmentsColor,
    dark: PropertyApartmentsDark,
    light: PropertyApartmentsLight
};
//# sourceMappingURL=index.js.map